import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private productIdSource = new BehaviorSubject<number | null>(null);
    productId$ = this.productIdSource.asObservable();

    setProductId(productId: number): void {
        this.productIdSource.next(productId);
    }

    getProductId(): number | null {
        return this.productIdSource.getValue();
    }

    clearProductId(): void {
        this.productIdSource.next(null);
    }
}